module.exports = "/images/ny-life2-6.jpg";